module.exports = __webpack_public_path__ + "static/media/Scale AP_Z1 Z2.8a5b3764.png";